import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { AuthGate } from './auth/AuthGate';
import { AuthProvider } from './auth/AuthProvider';
// Library first, then its opt-in document defaults and Olytic's own theme.
import '@olytic/foundation/styles.css';
import '@olytic/foundation/base.css';
import '@olytic/foundation/themes/olytic.css';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('The Mothership app root element is missing.');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AuthGate>
          <App />
        </AuthGate>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
